<template>
  <div class="reg-retrieve">
    <!-- 导航栏 -->
    <van-nav-bar :border="false" @click-left="onBack">
      <template #title>
        <span class="title">{{title}}</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" size=".7rem" color="#FF9D11" />
      </template>
    </van-nav-bar>
    <!-- 内容 -->
    <div class="reg-retrieve-wrapper">
      <!-- 注册和找回密码 -->
      <section class="reg-retrieve-cont">
        <div class="phone">
          <input type="number" v-model="phone" placeholder="请输入手机号" />
        </div>
        <div class="password">
          <input type="password" v-model="password" placeholder="请输入密码" v-if="id==1" />
          <input type="password" v-model="password" placeholder="请新输入密码" v-else />
        </div>
        <div class="code">
          <input type="number" placeholder="验证码" v-model="code" />
          <button @click.prevent="getCode(codeType)" class="code-btn" :disabled="!codeShow">
            <span v-show="codeShow">获取验证码</span>
            <span v-show="!codeShow" class="count">{{count}}</span>
          </button>
        </div>
        <p class="code-password" v-show="false">
          <router-link tag="span" :to="{name:'login'}">密码登录</router-link>
          <router-link tag="span" :to="{name:'login'}">手机号登录</router-link>
        </p>
        <p class="agreement" v-show="id==1">
          <span @click="isAgree=!isAgree">
            <van-icon name="success" color="#FF971C" v-show="isAgree" />
          </span>
          <span>已阅并同意遵守</span>
          <span>《61游戏用户协议》</span>
        </p>
        <div class="confirm" @click="onConfirm()">确定</div>
      </section>
    </div>
  </div>
</template>

<script>
import { contTools, lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "login",
  mixins: [contTools, lyTool],
  components: {},
  data() {
    return {
      phone: "",
      code: "",
      password: "",
      count: "",
      timer: "",
      codeShow: true,
      codeLogin: true, // 验证码登录显示
      isAgree: false, // 是否同意
      id: this.$route.query.id, // 地址栏id
      codeType: "" // 发送验证码的类型 reg注册 findpwd忘记密码
    };
  },
  watch: {},
  computed: {
    title: function() {
      switch (true) {
        case this.id == 1:
          this.codeType = "reg";
          return "注册";
          break;
        case this.id == 2:
          this.codeType = "findpwd";
          return "忘记密码";
          break;
        default:
          return "注册";
          break;
      }
    }
  },
  created() {},
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    switchLogin(type) {
      console.log(type);
      this.codeLogin = !this.codeLogin;
    },
    // 找回密码或注册
    onConfirm() {
      if (this.id == 1) {
        // 注册
        if (
          this.inputCheck(this.phone, "phone") &&
          this.inputCheck(this.password, "pwd") &&
          this.inputCheck(this.code, "yzm") &&
          this.inputCheck(this.isAgree, "checkbox")
        ) {
          let urlObj = comTools.getRequest();
          let data = comTools.assignObj(this.wapConfig(), {
            mobile: this.phone,
            pwd: this.getMd5(this.password),
            vcode: this.code,
            client_id: urlObj.client_id || this.getIdfa(),
            device_id:
              urlObj.device_id ||
              this.getMd5(`${urlObj.client_id}${urlObj.client_idv}`)
          });
          data.sign = comTools.querySort(data);
          wapApiFun.mobileReg(data).then(res => {
            if (res.code == 200) {
              console.log(res);
              this.loginBack(res.data.user_token, res.data.mobile);
            } else {
              this.$toast({
                message: res.msg,
                duration: 2000
              });
            }
          });
        }
        // this.loginBack("9hjsad2200033330");
      } else {
        // 找回密码
        if (
          this.inputCheck(this.phone, "phone") &&
          this.inputCheck(this.password, "pwd") &&
          this.inputCheck(this.code, "yzm")
        ) {
          let urlObj = comTools.getRequest();
          let data = comTools.assignObj(this.wapConfig(), {
            mobile: this.phone,
            pwd: this.getMd5(this.password),
            vcode: this.code,
            client_id: urlObj.client_id || this.getIdfa(),
            device_id:
              urlObj.device_id ||
              this.getMd5(`${urlObj.client_id}${urlObj.client_idv}`)
          });
          data.sign = comTools.querySort(data);
          wapApiFun.forgetPwd(data).then(res => {
            if (res.code == 200) {
              this.$toast({
                message: res.msg,
                duration: 2000
              });
              this.$router.push({ path: "/" });
            } else {
              this.$toast({
                message: res.msg,
                duration: 2000
              });
            }
          });
        }
      }
    },
    // 注册后直接登录
    loginBack(token) {
      this.$cookies.set("userToken", token);
      this.$cookies.set("mobile", mobile);
      let redirect = this.$cookies.set("routePath");
      this.$router.push({ path: redirect });
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.reg-retrieve {
  width: 100%;
  .van-nav-bar {
    .title {
      font-weight: bold;
    }
  }
  .reg-retrieve-wrapper {
    width: 100%;
    min-height: calc(~"100vh - 46px");
    background: url("~@assets/image/login-reg/bg.jpg") no-repeat;
    background-size: 100% auto;
    position: relative;

    .reg-retrieve-cont {
      width: 85%;
      margin: 0 auto;
      padding-top: 6rem;
      .phone,
      .password,
      .code {
        padding-bottom: 0.3rem;
        border-bottom: 1px solid #ddd;
        input {
          // padding-left: .2rem;
        }
      }
      .password {
        padding-top: 0.8rem;
      }
      .code {
        padding-top: 0.8rem;
        .jc-between();
        .code-btn {
          .theme-color();
          // font-size: 0.6rem;
        }
      }
      .reg-password,
      .code-password {
        .jc-between();
        .theme-color();
        padding: 0.5rem 0;
      }
      .agreement {
        text-align: center;
        padding-top: 0.3rem;
        .jc-content();
        span {
          font-size: 0.4rem;
          &:nth-of-type(1) {
            .theme-bd-color();
            width: 0.4rem;
            height: 0.4rem;
            .borderRadius(100%);
            margin-right: 0.1rem;
            .agree {
              display: inline-block;
              .theme-bg-color();
            }
          }
          &:nth-of-type(3) {
            .theme-color();
          }
        }
      }
      .confirm {
        // position: absolute;
        // bottom: 2.5rem;
        // left: 50%;
        // transform: translate(-50%, 0);
        width: 60%;
        margin: 2rem auto;
        text-align: center;
        color: #fff;
        .theme-bg-color();
        padding: 0.3rem 0;
        font-size: 0.5rem;
        .borderRadius(0.2rem);
      }
    }
  }
}
</style>